import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Speaker from "./Pages/Speaker/Speaker";
import Contact from "./Pages/Contact/Contact";
import Agenda from "./Pages/Agenda/Agenda";
import Accommodation from "./Pages/Accommodation/Accommodation";
import Attend from "./Pages/Attend/Attend";
import Sponsors from "./Pages/Sponsors/Sponsors";
import Nominees from "./Pages/Nominees/Nominees";
import Store from "./Pages/Store/Store";
import Package from "./Pages/Package/Package";
import Join from "./Pages/Join/Join";


function App() {
  return (
    <>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/about" element={<About/>} />
      <Route path="/speakers" element={<Speaker/>} />
      <Route path="/contact" element={<Contact/>} />
      <Route path="/agenda" element={<Agenda/>} />
      <Route path="/accommodation" element={<Accommodation/>} />
      <Route path="/attend" element={<Attend/>} />
      <Route path="/sponsors" element={<Sponsors/>} />
      <Route path="/nominees" element={<Nominees/>} />
      <Route path="/store" element={<Store/>} />
      <Route path="/packages" element={<Package/>} />
      <Route path="/join" element={<Join/>} />
    </Routes>
       
    </BrowserRouter>
      </>
  );
}

export default App;
